import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "photo-viewer-main" }
const _hoisted_3 = ["data-swiper-slide-index"]
const _hoisted_4 = { class: "photo-viewer-image-wrap" }
const _hoisted_5 = ["src", "alt", "loading"]
const _hoisted_6 = {
  key: 0,
  class: "photo-viewer-comment"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "photo" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "photo-viewer-image-wrap" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "photo-viewer-comment"
}

import type Swiper from 'swiper';
import { register } from 'swiper/element/bundle';
import { ref, onMounted } from 'vue';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import IModal from '@/js/components/molecules/IModal.vue';
import PhotoDialog from './PhotoDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhotoViewer',
  props: {
    pictures: {},
    hasThumbnail: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const injectStyles = [
  `
  :host .swiper-button-prev,
  :host .swiper-button-next {
    color: var(--color-white);
    background: none rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    height: 38px;
    width: 38px;
  }
  :host .swiper-button-prev:hover,
  :host .swiper-button-next:hover {
    opacity: 0.7;
  }
  :host .swiper-button-disabled {
    opacity: 0.25;
    pointer-events: initial;
  }
  :host .swiper-button-prev > svg {
    height: 50%;
    margin-right: 3px;
  }
  :host .swiper-button-next > svg {
    height: 50%;
    margin-left: 3px;
  }
  `,
];
const wrapperRef = ref();
const thumbRef = ref<HTMLUListElement>();
const isShowModal = ref(false);
const swiper = ref<Swiper>();
const currentIndex = ref(0);
const getImageUrlToFillSquare = (path: string, width: number, height: number, squareSize: number) => {
  let w: number | undefined;
  let h: number | undefined;

  if (width > height) {
    h = squareSize;
  } else {
    w = squareSize;
  }

  return dynamicImageUrl(path, w, h);
};
const onClickThumbnail = (index: number) => {
  swiper.value?.slideToLoop(index);
};
const onChangeDialogSlide = (index: number) => {
  swiper.value?.slideToLoop(index);
};

// register Swiper custom elements
register();

onMounted(() => {
  if (props.pictures.length > 1) {
    Object.assign(wrapperRef.value, {
      loop: true,
      navigation: true,
      injectStyles,
    });

    wrapperRef.value.addEventListener('swiperprogress', (e: { detail: [Swiper, number] }) => {
      [swiper.value] = e.detail;
    });
    wrapperRef.value.addEventListener('swiperslidechange', () => {
      if (currentIndex.value !== swiper.value?.realIndex) {
        currentIndex.value = swiper.value?.realIndex ?? 0;
        thumbRef.value?.children[currentIndex.value]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
    wrapperRef.value.initialize();
  }
});

return (_ctx: any,_cache: any) => {
  return (_ctx.pictures.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("swiper-container", {
            ref_key: "wrapperRef",
            ref: wrapperRef,
            init: "false"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pictures, (picture, index) => {
              return (_openBlock(), _createElementBlock("swiper-slide", {
                key: index,
                "data-swiper-slide-index": index
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: getImageUrlToFillSquare(picture.path, picture.width, picture.height, 640),
                    alt: picture.alt,
                    loading: index === 0 ? 'eager' : 'lazy',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowModal.value = true))
                  }, null, 8, _hoisted_5),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  (picture.comment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(picture.comment), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_3))
            }), 128))
          ], 512),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.photoPager)
          }, _toDisplayString(`${currentIndex.value + 1} / ${_ctx.pictures.length}`), 3)
        ]),
        _cache[6] || (_cache[6] = _createTextVNode()),
        (_ctx.hasThumbnail)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              ref_key: "thumbRef",
              ref: thumbRef,
              class: "photo-viewer-thumbnail"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pictures, (picture, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass(index === currentIndex.value ? 'is-current' : ''),
                  onClick: ($event: any) => (onClickThumbnail(index))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: getImageUrlToFillSquare(picture.path, picture.width, picture.height, 120),
                      alt: picture.alt,
                      width: "40",
                      height: "40"
                    }, null, 8, _hoisted_9)
                  ])
                ], 10, _hoisted_7))
              }), 128))
            ], 512))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createTextVNode()),
        _createVNode(IModal, {
          modelValue: isShowModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowModal).value = $event)),
          "destroy-on-close": true,
          fullscreen: true
        }, {
          default: _withCtx(() => [
            _createVNode(PhotoDialog, {
              pictures: _ctx.pictures,
              "current-index": currentIndex.value,
              "is-show-modal": isShowModal.value,
              "inject-styles": injectStyles,
              onChange: onChangeDialogSlide
            }, null, 8, ["pictures", "current-index", "is-show-modal"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: getImageUrlToFillSquare(_ctx.pictures[0].path, _ctx.pictures[0].width, _ctx.pictures[0].height, 640),
            alt: _ctx.pictures[0].alt,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowModal.value = true))
          }, null, 8, _hoisted_12),
          _cache[8] || (_cache[8] = _createTextVNode()),
          (_ctx.pictures[0].comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.pictures[0].comment), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        _createVNode(IModal, {
          modelValue: isShowModal.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowModal).value = $event)),
          "destroy-on-close": true,
          fullscreen: true
        }, {
          default: _withCtx(() => [
            _createVNode(PhotoDialog, {
              pictures: _ctx.pictures,
              "is-show-modal": isShowModal.value
            }, null, 8, ["pictures", "is-show-modal"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
}
}

})